import React, { Fragment, useEffect } from "react";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/Help-Desk-Components/Footer/Footer";
import HeaderBuga from "../../components/header6/Header6";
import icon1 from "../../images/moneytransfer/time-savings.png";
import icon2 from "../../images/moneytransfer/exchange2.png";
import icon3 from "../../images/moneytransfer/pound-sterling.png";
import icon4 from "../../images/moneytransfer/take-off.png";
import iIcon from "../../images/icon/Buga/eye-icon.svg";
import mImg from "../../images/moneytransfer/money-transfer.png";

const workItems = [
  {
    id: 1,
    icon: icon1,
    title: "Save Time",
    content:
      "Send money to your family and loved ones from your phone at the comfort of your home",
  },
  {
    id: 2,
    icon: icon2,
    title: "Rate Promise",
    content:
      "We promise competitive rates, and deposit amount confirmed to you.",
  },
  {
    id: 3,
    icon: icon3,
    title: "We're Zero Fees",
    content:
      "Our pricing is highly competitive and fully transparent, Compare us with the competition. You save more with us.",
  },
  {
    id: 4,
    icon: icon4,
    title: "We're Fast",
    content:
      "Add Money lets you quickly and reliably send funds to friends and family worldwide. ",
  },
];

const MoneyTransfer = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <Fragment>
      <div className="body_wrap sco_agency">
        <HeaderBuga />
        <section
          className="page-title pt-100  pos-rel bg_img breadcrums-bgr"
          //   style={{ backgroundImage: `url(${Bg})` }}
        >
          <div className="container">
            <div className="page-title-wrap ">
              <div className="row mt-none-30 align-items-center text-center">
                <div className="col-xl-12 col-lg-8 mt-30">
                  <div className="page-title-box">
                    <h2 className="title">Money Transfer</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className={`work  pb-130 ${props.bg}`}>
          <div className="container pt-50">
            <div className="sec-title--two text-center ">
              <div className="sub-title">
                <img src={iIcon} alt="" />
                We are Buga Money
              </div>
              <h2 className="title pb-20">Why people work with us</h2>
            </div>

            <div className="tp-work-wrapp">
              <div className="row mt-none-30">
                {workItems.map((item) => (
                  <div className="col-lg-6 mt-30" key={item.id}>
                    <div className="tp-work-item">
                      <div className="xb-item--inner ul_li">
                        <div className="xb-item--icon">
                          <img src={item.icon} alt={item.title} />
                        </div>
                        <div className="xb-item--holder">
                          <h3 className="xb-item--title">{item.title}</h3>
                          <p className="xb-item--content">{item.content}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="award" style={{ backgroundColor: "#f6f6f8" }}>
          <div className="container">
            <div className="row justify-content-center text-center">
              <div className="col-lg-10 ">
                <div className="service-info ab-award-content">
                  <div className="sec-title--two">
                    <h2
                      className="title wow skewIn text-center"
                      data-wow-delay="100ms"
                      data-wow-duration="600ms"
                    >
                      Reliable money transfer service
                    </h2>

                    <p
                      className="wow fadeInUp text-center mx-auto pt-30"
                      style={{ maxWidth: "700px" }}
                      data-wow-delay="300ms"
                      data-wow-duration="600ms"
                    >
                      It's your hard-earned money, and we get it. You deserve
                      better rates and pay less, we make sure to offer you the
                      best rates and keep your fees to a minimum.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="row justify-content-center align-items-center pb-100 mt-50">
              <div className="col-xl-7 col-lg-6 col-md-10 ">
                <div className="team-wrap ul_li_between">
                  <ul className="xb-item--skill list-unstyled ">
                    <li className="mb-5">
                      <h2 className="xb-item--title mb-2">Powerful Mobile and Web App</h2>
                      <p>Download our app from the App Store or Play Store. This is the only app you will require for your money transfer need.</p>
                    </li>
                    <li className="mb-5">
                      <h2 className="xb-item--title mb-2">Brings More Transparency and Speed</h2>
                      <p>Yes, we will let you know what's the status of your transfer. You will get notifications such as transfer initiated, processed or deposited.</p>
                    </li>
                    <li>
                      <h2 className="xb-item--title mb-2">Secure and Safe</h2>
                      <p>Your personal data is always secure with us. We do not store any of your payment details and always encrypt data while storing on our server.</p>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-xl-5 col-lg-6 col-md-10 text-center ">
                <div className="money-transfer-image">
                  <img
                    src={mImg}
                    alt="image"
                    className="img-fluid mx-auto d-block mt-25"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default MoneyTransfer;
